import React, { useMemo, useCallback, memo } from 'react';
import cx from 'clsx';

import { IconRcArrowDown } from '@/assets';
import { CHAINS_LIST, CHAIN_ID_ALL } from '@/utils';

import style from './index.module.css';

type CurrentChainLabelProps = {
  value?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  placeholder?: string;
  colored?: boolean;
  error?: boolean;
  disabled?: boolean;
};

export const CurrentChainLabel = memo(
  ({
    value,
    className,
    onClick,
    placeholder,
    colored = true,
    error,
    disabled,
  }: CurrentChainLabelProps) => {
    // 放到 render 时间再组装数组，不然的话，还是本地数据
    const ALL_CHAINS = useMemo(() => [CHAIN_ID_ALL, ...CHAINS_LIST], []);

    const handleClick = useCallback(
      (event: React.MouseEvent<HTMLDivElement>) => {
        if (!disabled) {
          onClick?.(event);
        }
      },
      [disabled, onClick],
    );

    const currentChain = useMemo(
      () => ALL_CHAINS.find(x => x.serverId === value)?.name,
      [value, ALL_CHAINS],
    );

    return (
      <div
        className={cx(
          style.chainLable,
          colored && style.isColored,
          error && style.isError,
          disabled && style.isDisabled,
          currentChain && style.isSelected,
          className,
        )}
        onClick={handleClick}>
        <div className={style.chainLableText}>{currentChain || placeholder}</div>
        <IconRcArrowDown className={style.dropdownIcon} />
      </div>
    );
  },
);
